import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface UserStats {
  user_id: number;
  username: string;
  organisation: string;
  total_tabs: number;
  active_tabs: number;
  deleted_tabs: number;
  company_searches: number;
  theme_searches: number;
  top_companies: Array<{ name: string; count: number }>;
  top_themes: Array<{ name: string; count: number }>;
}

export interface DailyActivity {
  date: string;
  count: number;
  users: Array<{ username: string; count: number }>;
}

export interface OverviewPayload {
  users: UserStats[];
  daily_activity: DailyActivity[];
}

export interface TabDetail {
  tab_id: string;
  tab_name: string;
  search_type: string;
  created_at: string | null;
  is_deleted: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SiaStatisticsService {
  constructor(private http: HttpClient) {}

  getOverview(dateFrom?: string | null, dateTo?: string | null, excludeQuantip: boolean = true): Observable<{ payload: OverviewPayload }> {
    const params: string[] = [];
    if (dateFrom) params.push(`date_from=${dateFrom}`);
    if (dateTo) params.push(`date_to=${dateTo}`);
    params.push(`exclude_quantip=${excludeQuantip}`);
    const url = '/backend/siaStatistics/statistics/overview' + (params.length ? '?' + params.join('&') : '');

    return this.http.get<{ payload: OverviewPayload }>(url, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('current_user_token') }
    });
  }

  getUserTabs(userId: number, dateFrom?: string | null, dateTo?: string | null): Observable<{ payload: TabDetail[] }> {
    const params: string[] = [];
    if (dateFrom) params.push(`date_from=${dateFrom}`);
    if (dateTo) params.push(`date_to=${dateTo}`);
    const url = `/backend/siaStatistics/statistics/user-tabs/${userId}` + (params.length ? '?' + params.join('&') : '');

    return this.http.get<{ payload: TabDetail[] }>(url, {
      headers: { Authorization: 'Bearer ' + localStorage.getItem('current_user_token') }
    });
  }
}
